import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import {
  Pill, BookHeart, Settings, PawPrint
} from 'lucide-react';
import BeanIcon from './Custom Icons/KodaIcon';
import { NavLink } from './NavLink';
import { useLanguage } from '../functions/useLanguage';
import { useBean } from '../context/BeanContext';
import { useData } from '../context/DataContext';

export function NavRail() {
  const location = useLocation();
  const { t } = useLanguage();
  const { profile } = useBean();
  const { pendingUploadCount } = useData();

  const isBeanPage = location.pathname === '/kodafellowship';
  if (isBeanPage) return null;

  return (
    <aside className="hidden flex-col items-center py-6 z-20 shrink-0 fixed left-0 top-16 h-[calc(100vh-64px)] bg-white">
      <nav className="flex flex-col items-center gap-6 w-full">
        {/* Bean FAB — top slot */}
        <Link to="/kodafellowship" data-tour="nav-bean" className="flex flex-col items-center justify-center w-full opacity-95 hover:opacity-100 transition-opacity">
          <BeanIcon width={80} height={80} beanColor={profile?.roomie_color ?? undefined} />
        </Link>
        <NavLink to="/vitals" icon={<PawPrint size={24} />} label={t('nav.records')} active={location.pathname === '/vitals'} dataTour="nav-records" />
        <NavLink to="/meds" icon={<Pill size={24} />} label={t('nav.meds')} active={location.pathname === '/meds'} dataTour="nav-meds" />
        <NavLink to="/library" icon={<BookHeart size={24} />} label={t('nav.guide')} active={location.pathname.startsWith('/library')} dataTour="nav-guide" badge={pendingUploadCount || undefined} />
        <NavLink to="/settings" icon={<Settings size={24} />} label={t('account.title')} active={location.pathname.startsWith('/settings')} />
      </nav>
    </aside>
  );
}
